import _ from 'lodash'
import PATH from 'quick-quote/constants/path'

import RiderGroup from 'quick-quote/product-common/coverage-plan/components/rider/rider-group'
import TotalPremiumInput from 'quick-quote/product-common/coverage-plan/components/basic-plan/total-premium-input'
import { Redirect } from 'react-router-dom'
import { InsuredInformationBreadcrumb } from 'quick-quote/components'

import BasicPlan from 'quick-quote/product-common/coverage-plan/components/basic-plan/basic-plan'
import CancerX5Selection from './cancerX5-selection'
import ModelFactorSelection from 'quick-quote/product-common/coverage-plan/components/basic-plan/model-factor-selection'
import LifeReadyProductSelection from './life-ready-product-selection'
import KoomverCoverProductSelection from './koomver-cover-selection'
import KoomverCompensateProductSelection from './koomver-compensate-selection'
import KoomverSoshieldProductSelection from './koomver-soshield-selection'
import LifeTreasureProductSelection from './life-treasure-product-selection'
import RokeRaiSoShieldProductSelection from './roke-rai-so-shield-product-selection'
import CIComboProductSelection from './ci-combo-product-selection'
import HealthComboProductSelection from './health-combo-product-selection'
import KoomverRokeRaiProductSelection from './koomver-roke-rai-selection'

import LifeProtectPlusProductSelection from 'quick-quote/product-life-protect-plus/coverage-plan/components/life-protect-plus-product-selection'
import KoomverCompensateWLF99HProductSelection from 'quick-quote/product-life-protect-plus/coverage-plan/components/koomver-compensate-WLF99H-selection'
import KoomverRokeRaiWLF99HProductSelection from 'quick-quote/product-life-protect-plus/coverage-plan/components/koomver-roke-rai-WLF99H-selection'
import RokeRaiSoShieldLifeProtectPlusProductSelection from 'quick-quote/product-life-protect-plus/coverage-plan/components/roke-rai-so-shield-life-protect-plus-product-selection'
import ComboCILifeProtectPlusProductSelection from 'quick-quote/product-life-protect-plus/coverage-plan/components/combo-ci-life-protect-plus-product-selection'
import ComboHealthEssentialLifeProtectPlusProductSelection from 'quick-quote/product-life-protect-plus/coverage-plan/components/combo-health-essential-life-protect-plus-product-selection'
import LifeProtectPlusSABooster from 'quick-quote/product-life-protect-plus/coverage-plan/components/life-protect-plus-sa-booster'

import VALUES from 'core/data-model/constants/values'

const CoveragePlan = ({
  toggleRider,
  riderCodes,
  canProceedToCoveragePlan,
  displayProduct,
  editRiderSumAssured,
  editRiderSelectedPlan,
}) => {
  if (!canProceedToCoveragePlan) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  }
  let displayProductSelections = function (displayProduct) {
    let displayProductCode = _.get(displayProduct, 'code')
    switch (displayProductCode) {
      case 'CANCERX5-1':
      case 'CANCERX5-2':
      case 'CANCERX5-3':
        return <CancerX5Selection />
      case 'KOOMVER-COVER-1':
      case 'KOOMVER-COVER-2':
        return <KoomverCoverProductSelection />
      case 'KOOMVER-COMPENSATE-1':
      case 'KOOMVER-COMPENSATE-2':
      case 'KOOMVER-COMPENSATE-3':
      case 'KOOMVER-COMPENSATE-4':
        return <KoomverCompensateProductSelection />
      case 'KOOMVER-COMPENSATE-1-WLF99H':
      case 'KOOMVER-COMPENSATE-2-WLF99H':
      case 'KOOMVER-COMPENSATE-3-WLF99H':
      case 'KOOMVER-COMPENSATE-4-WLF99H':
        return <KoomverCompensateWLF99HProductSelection />
      case 'H99F06A':
      case 'H99F12A':
      case 'H99F18A':
        return <LifeTreasureProductSelection />
      case 'ROKE-RAI-SO-SHIELD-W99FU06':
      case 'ROKE-RAI-SO-SHIELD-W99FU12':
      case 'ROKE-RAI-SO-SHIELD-W99FU18':
      case 'ROKE-RAI-SO-SHIELD-W99FH18':
      case 'ROKE-RAI-SO-SHIELD-W99FU99':
      case 'ROKE-RAI-SO-SHIELD-W99FH99':
        return <RokeRaiSoShieldProductSelection />
      case 'KOOMVER-SOSHIELD-1':
      case 'KOOMVER-SOSHIELD-2':
      case 'KOOMVER-SOSHIELD-3':
        return <KoomverSoshieldProductSelection />
      case 'ROKE-RAI-SO-SHIELD-WLF09H':
      case 'ROKE-RAI-SO-SHIELD-WLF19H':
      case 'ROKE-RAI-SO-SHIELD-WLF99H':
        return <RokeRaiSoShieldLifeProtectPlusProductSelection />
      case 'CI-COMBO-W99FU18':
      case 'CI-COMBO-W99FH18':
      case 'CI-COMBO-W99FU99':
      case 'CI-COMBO-W99FH99':
        return <CIComboProductSelection />
      case 'HEALTH-COMBO-W99FU18':
      case 'HEALTH-COMBO-W99FH18':
      case 'HEALTH-COMBO-W99FU99':
      case 'HEALTH-COMBO-W99FH99':
        return <HealthComboProductSelection />
      case 'KOOMVER-ROKE-RAI-1':
      case 'KOOMVER-ROKE-RAI-2':
      case 'KOOMVER-ROKE-RAI-3':
        return <KoomverRokeRaiProductSelection />
      case 'KOOMVER-ROKE-RAI-1-WLF99H':
      case 'KOOMVER-ROKE-RAI-2-WLF99H':
      case 'KOOMVER-ROKE-RAI-3-WLF99H':
        return <KoomverRokeRaiWLF99HProductSelection />
      case 'W99F06A':
      case 'HEALTH-ULTRA-PACKAGE-WLF99HX':
      case 'HEALTH-EXTRA-PACKAGE-WLF99HX':
        return null
      case 'WLF09L':
      case 'WLF09H':
      case 'WLF19L':
      case 'WLF19H':
      case 'WLF99L':
      case 'WLF99H':
        return <LifeProtectPlusProductSelection />
      case 'COMBO-CI-WLF19H':
      case 'COMBO-CI-WLF99H':
        return <ComboCILifeProtectPlusProductSelection />
      case 'COMBO-HEALTH-ESSENTIAL-WLF19H':
      case 'COMBO-HEALTH-ESSENTIAL-WLF99H':
        return <ComboHealthEssentialLifeProtectPlusProductSelection />
      default:
        return <LifeReadyProductSelection />
    }
  }

  const isLifeProtectPlus = Object.values(VALUES.LIFEPROTECT_PLUS_CODE).includes(_.get(displayProduct, 'code'))

  return (
    <div>
      <InsuredInformationBreadcrumb />
      <div id="coverage-plan">
        <div className="content">
          <div id="basic-plan">
            <div className="content">
              <ModelFactorSelection />
              {displayProductSelections(displayProduct)}
              <BasicPlan />
            </div>
          </div>
          <div id="total-premium">
            <TotalPremiumInput />
          </div>
          {isLifeProtectPlus && <LifeProtectPlusSABooster />}
          <RiderGroup
            riderCodes={riderCodes}
            toggleRider={toggleRider}
            editRiderSumAssured={editRiderSumAssured}
            editRiderSelectedPlan={editRiderSelectedPlan}
          />
        </div>
      </div>
    </div>
  )
}

export default CoveragePlan
